import NewIssue from "./components/NewIssueForm";

export default NewIssue